import type { UserOrganization } from "@shared/types";
import { Form, Input, InputNumber, Select, Switch } from "antd";
import { useEffect } from "react";
import { useDevicesStore } from "../store/devices.store";
import type { CreateDeviceRequest, DeviceDirection } from "../types";

const DIRECTION_OPTIONS: { value: DeviceDirection; label: string }[] = [
	{ value: "IN", label: "Kirish" },
	{ value: "OUT", label: "Chiqish" },
	{ value: "BOTH", label: "Ikkalasi" },
];

export function DeviceForm({
	form,
	organizationId,
	organizations = [],
	hideOrganization,
}: {
	form: ReturnType<typeof Form.useForm<CreateDeviceRequest>>[0];
	organizationId?: string;
	organizations?: UserOrganization[];
	hideOrganization?: boolean;
}) {
	const editingDevice = useDevicesStore((s) => s.editingDevice);

	useEffect(() => {
		if (editingDevice) {
			form.setFieldsValue({
				name: editingDevice.name,
				serialNumber: editingDevice.serialNumber,
				macAddress: editingDevice.macAddress ?? undefined,
				ipAddress: editingDevice.ipAddress,
				port: editingDevice.port,
				direction: editingDevice.direction,
				locationDescription: editingDevice.locationDescription ?? undefined,
				organizationId: editingDevice.organizationId,
				username: editingDevice.username,
				password: editingDevice.password,
				status: editingDevice.status,
				isActive: editingDevice.isActive,
			});
		} else {
			form.resetFields();
			form.setFieldsValue({ status: "offline" });
			if (organizationId) {
				form.setFieldsValue({ organizationId });
			}
		}
	}, [editingDevice, form, organizationId]);

	const orgOptions = organizations.map((o) => ({ value: o.id, label: o.name }));

	return (
		<Form form={form} layout="vertical" requiredMark={false} className="mt-4">
			{(hideOrganization || editingDevice) && organizationId ? (
				<Form.Item name="organizationId" hidden initialValue={organizationId}>
					<Input type="hidden" />
				</Form.Item>
			) : !(hideOrganization || editingDevice) && orgOptions.length > 0 ? (
				<Form.Item
					name="organizationId"
					label="Tashkilot"
					rules={[{ required: true, message: "Tashkilotni tanlang" }]}
				>
					<Select placeholder="Tashkilotni tanlang" options={orgOptions} />
				</Form.Item>
			) : null}

			<div className="grid grid-cols-2 gap-4">
				<Form.Item name="name" label="Nomi" rules={[{ required: true, message: "Nomi kiriting" }]}>
					<Input placeholder="Entrance Camera 1" />
				</Form.Item>

				<Form.Item
					name="serialNumber"
					label="Seriya raqami"
					rules={[{ required: true, message: "Seriya raqamini kiriting" }]}
				>
					<Input placeholder="SN-123456789" />
				</Form.Item>

				<Form.Item name="macAddress" label="MAC manzil">
					<Input placeholder="00:00:00:00:00:00" />
				</Form.Item>

				<Form.Item
					name="ipAddress"
					label="IP manzil"
					rules={[{ required: true, message: "IP manzilni kiriting" }]}
				>
					<Input placeholder="192.168.1.10" />
				</Form.Item>

				<Form.Item name="port" label="Port">
					<InputNumber min={1} max={65535} placeholder="80" className="w-full" />
				</Form.Item>

				<Form.Item
					name="direction"
					label="Yo'nalish"
					rules={[{ required: true, message: "Yo'nalishni tanlang" }]}
				>
					<Select placeholder="Tanlang" options={DIRECTION_OPTIONS} />
				</Form.Item>

				<Form.Item name="locationDescription" label="Joy tavsifi">
					<Input placeholder="Main entrance" />
				</Form.Item>

				<Form.Item
					name="username"
					label="Username"
					rules={[{ required: true, message: "Usernameni kiriting" }]}
				>
					<Input placeholder="admin" />
				</Form.Item>

				<Form.Item
					name="password"
					label={editingDevice ? "Yangi parol (ixtiyoriy)" : "Parol"}
					rules={
						editingDevice
							? []
							: [
									{ required: true, message: "Parolni kiriting" },
									{ min: 1, message: "Kamida 1 ta belgi" },
								]
					}
				>
					<Input.Password
						placeholder={editingDevice ? "O'zgartirmasangiz bo'sh qoldiring" : "admin123"}
					/>
				</Form.Item>

				<Form.Item name="status" hidden initialValue="offline">
					<Input type="hidden" />
				</Form.Item>

				<Form.Item name="isActive" label="Faol" valuePropName="checked" initialValue={true}>
					<Switch />
				</Form.Item>
			</div>
		</Form>
	);
}
